var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEngine = function SvgEngine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8 4a1.333 1.333 0 1 0 0 2.667h4V8.8h-5.6a3.733 3.733 0 0 0-3.734 3.733V15.2H5.334v-5.067a1.333 1.333 0 1 0-2.667 0v12.8a1.333 1.333 0 1 0 2.667 0v-5.066h2.132v2.666a3.733 3.733 0 0 0 3.734 3.734h5.227l3.023 2.838c.247.232.574.362.913.362H25.6a3.733 3.733 0 0 0 3.733-3.734v-11.2A3.733 3.733 0 0 0 25.6 8.8h-6.134V6.667h4.712a1.333 1.333 0 0 0 0-2.667H12.8Zm3.467 10.667a1.333 1.333 0 0 0-2.666 0v3.2a1.333 1.333 0 0 0 2.666 0v-3.2Zm4.267 0a1.333 1.333 0 0 0-2.666 0v3.2a1.333 1.333 0 0 0 2.666 0v-3.2Zm2.933-1.334c.736 0 1.333.597 1.333 1.334v3.2a1.333 1.333 0 0 1-2.667 0v-3.2c0-.737.597-1.334 1.334-1.334Z",
    fill: "#F08200"
  })));
};
export default SvgEngine;